import "whatwg-fetch";
import { API_ROOT, makeRequest } from "../../services/qbankApi";
import { QuestionType, CreateTestData } from "../models";

type CoreTreeData = { name: string; count: number };
export type ProductTreeData = CoreTreeData & {
    type: "Product";
    children: SubjectTreeData[];
};
export type SubjectTreeData = CoreTreeData & {
    type: "Subject";
    children: CategoryTreeData[];
};
export type CategoryTreeData = CoreTreeData & {
    type: "Category";
    children: SubcategoryTreeData[];
};
export type SubcategoryTreeData = CoreTreeData & {
    type: "SubCategory";
    subCategoryId: number;
};
export type TreeData =
    | ProductTreeData
    | SubjectTreeData
    | CategoryTreeData
    | SubcategoryTreeData;

// Ideally would be handled by the API, but filter here for now.
const notEmpty = ({ count }: CoreTreeData) => count !== 0;
function removeEmpty<T extends TreeData>(tree: T): T {
    if(tree.type === "SubCategory") { return tree };
    const newChildren = ((tree as any).children as TreeData[])
        .filter(notEmpty)
        .map(removeEmpty)
    return { ...tree, children: newChildren };
}

export async function getProductTree(productId: string) {
    const url = `${API_ROOT}products/${productId}/tree`;
    const res = await (await makeRequest("GET", url)).json();
    return removeEmpty(res.productTree as ProductTreeData);
}

export type QuestionTypeCounts = Record<QuestionType, number>;

export async function getQuestionTypeCounts(
    userId: string,
    subCategories: number[],
) {
    const url = `${API_ROOT}questiontypes/users/${userId}`;
    const res = await (await makeRequest("POST", url, {
        subCategories,
    })).json();
    const counts = res.questionTypeDataMap;
    return {
        all: counts.ALL,
        unused: counts.UNUSED,
        incorrect: counts.INCORRECT,
        correct: counts.CORRECT,
        unanswered: counts.UNANSWERED,
        flagged: counts.FLAGGED || 0,
    } as QuestionTypeCounts;
}

export async function createTest(data: CreateTestData) {
    const url = `${API_ROOT}tests`;
    const res = await makeRequest("POST", url, {
        productUuid: data.productUuid,
        name: data.name,
        numQuestions: data.numberOfQuestions,
        questionTypes: data.questionType.toUpperCase(),
        subCategories: data.categories,
        testMode: data.mode,
    });
    return await res.json();
}
